import { useState } from "react";
import { G, D, D3, D4, BR, TX, T2, PILARES } from "../theme";
import { calcScore, getMedia, getCl } from "../utils";
import { salvarResposta, desativarLink, notificarCoach, buscarPerfil } from "../supabase";

export default function FormAluno(props) {
  var link = props.link;
  var isUniversal = link.tipo === "universal" || link.aluno_nome === "__universal__";
  var [etapa, setEtapa] = useState(isUniversal ? "identificacao" : "intro");
  var [pilarIdx, setPilarIdx] = useState(0);
  var [respostas, setRespostas] = useState({});
  var [scores, setScores] = useState(null);
  var [enviado, setEnviado] = useState(false);
  var [alunoNome, setAlunoNome] = useState("");
  var [alunoEmail, setAlunoEmail] = useState("");
  var [alunoWhatsapp, setAlunoWhatsapp] = useState("");
  var [alunoIdade, setAlunoIdade] = useState("");
  var [idErr, setIdErr] = useState("");

  var inp = {width:"100%",background:D4,border:"1px solid "+BR,borderRadius:8,padding:"12px 14px",color:TX,fontSize:14,boxSizing:"border-box",outline:"none"};

  function nomeAluno() { return isUniversal ? alunoNome : link.aluno_nome; }

  function setResp(key, idx, val) {
    setRespostas(function(prev) {
      var n = Object.assign({}, prev);
      n[key] = Object.assign({}, prev[key] || {});
      n[key][idx] = val;
      return n;
    });
  }
  function pilarOk() {
    var p = PILARES[pilarIdx];
    for (var i = 0; i < p.perguntas.length; i++) {
      if (!respostas[p.key] || respostas[p.key][i] === undefined) return false;
    }
    return true;
  }
  function avancar() {
    if (pilarIdx < PILARES.length-1) { setPilarIdx(function(p){ return p+1; }); return; }
    var sc = {};
    for (var i = 0; i < PILARES.length; i++) sc[PILARES[i].key] = calcScore(respostas, PILARES[i]);
    setScores(sc); setEtapa("resultado");
  }

  async function enviar() {
    var med = getMedia(scores);
    var cl = getCl(med);
    var extra = isUniversal ? { email: alunoEmail, whatsapp: alunoWhatsapp, idade: alunoIdade ? parseInt(alunoIdade) : null } : null;
    await salvarResposta(link.id, link.professor_id, nomeAluno(), scores, med, cl.label, extra);

    // Links universais ficam ativos (reutilizáveis)
    if (!isUniversal) await desativarLink(link.token);

    try {
      var perfil = await buscarPerfil(link.professor_id);
      var emailCoach = perfil && perfil.email ? perfil.email : null;
      if (emailCoach) {
        await notificarCoach(emailCoach, perfil.nome || link.professor_nome, nomeAluno(), med, cl.label, scores);
      }
    } catch(e) {
      console.error("Erro na notificação:", e);
    }

    setEnviado(true);
    if (props.onEnviado) props.onEnviado();
  }

  var bg = { backgroundColor:D, minHeight:"100vh", color:TX, fontFamily:"Arial,sans-serif" };

  if (enviado) return (
    <div style={{...bg,display:"flex",alignItems:"center",justifyContent:"center",flexDirection:"column",gap:12,textAlign:"center",padding:"2rem"}}>
      <div style={{fontSize:48}}>✅</div>
      <div style={{fontSize:22,fontWeight:700,color:"#fff"}}>Avaliação enviada com sucesso!</div>
      <div style={{fontSize:14,color:T2}}>{link.professor_nome} receberá seus resultados e entrará em contato.</div>
    </div>
  );

  // Etapa de identificação (apenas links universais)
  if (etapa === "identificacao") return (
    <div style={{...bg,display:"flex",alignItems:"center",justifyContent:"center",padding:"2rem"}}>
      <div style={{maxWidth:460,width:"100%"}}>
        <div style={{textAlign:"center",marginBottom:28}}>
          <div style={{fontSize:11,color:G,letterSpacing:3,fontWeight:600,marginBottom:10}}>RMS 2.0 — DIAGNÓSTICO GRATUITO</div>
          <div style={{fontSize:24,fontWeight:700,color:"#fff",marginBottom:6}}>Raio-X do Emagrecimento</div>
          <div style={{fontSize:13,color:T2}}>Enviado por <span style={{color:G}}>{link.professor_nome}</span></div>
        </div>
        <div style={{background:D3,border:"1px solid "+BR,borderRadius:14,padding:"1.5rem",marginBottom:16}}>
          <div style={{fontSize:14,fontWeight:600,color:G,marginBottom:16}}>Seus dados</div>
          <div style={{marginBottom:14}}>
            <label style={{fontSize:11,color:T2,display:"block",marginBottom:6}}>Nome completo *</label>
            <input value={alunoNome} onChange={function(e){ setAlunoNome(e.target.value); }} placeholder="Seu nome" style={inp}/>
          </div>
          <div style={{marginBottom:14}}>
            <label style={{fontSize:11,color:T2,display:"block",marginBottom:6}}>E-mail *</label>
            <input type="email" value={alunoEmail} onChange={function(e){ setAlunoEmail(e.target.value); }} placeholder="seu@email.com" style={inp}/>
          </div>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12,marginBottom:14}}>
            <div>
              <label style={{fontSize:11,color:T2,display:"block",marginBottom:6}}>WhatsApp *</label>
              <input value={alunoWhatsapp} onChange={function(e){ setAlunoWhatsapp(e.target.value); }} placeholder="(11) 99999-9999" style={inp}/>
            </div>
            <div>
              <label style={{fontSize:11,color:T2,display:"block",marginBottom:6}}>Idade *</label>
              <input type="number" value={alunoIdade} onChange={function(e){ setAlunoIdade(e.target.value); }} placeholder="Ex: 30" style={inp}/>
            </div>
          </div>
          {idErr && <div style={{fontSize:12,color:"#E53935",marginBottom:12}}>{idErr}</div>}
          <button onClick={function(){
            if (!alunoNome.trim() || !alunoEmail.trim() || !alunoWhatsapp.trim() || !alunoIdade.trim()) {
              setIdErr("Preencha todos os campos."); return;
            }
            setIdErr(""); setEtapa("intro");
          }} style={{width:"100%",padding:"14px 0",background:G,color:D,border:"none",borderRadius:10,fontWeight:700,fontSize:15,cursor:"pointer"}}>
            Continuar →
          </button>
        </div>
        <div style={{fontSize:11,color:"#555",textAlign:"center"}}>Leva cerca de 5 minutos • 100% gratuito</div>
      </div>
    </div>
  );

  if (etapa === "intro") return (
    <div style={{...bg,display:"flex",alignItems:"center",justifyContent:"center",padding:"2rem"}}>
      <div style={{maxWidth:460,width:"100%",textAlign:"center"}}>
        <div style={{fontSize:11,color:G,letterSpacing:3,fontWeight:600,marginBottom:10}}>RMS 2.0 — DIAGNÓSTICO GRATUITO</div>
        <div style={{fontSize:26,fontWeight:700,color:"#fff",marginBottom:6}}>Raio-X do Emagrecimento</div>
        <div style={{fontSize:13,color:T2,marginBottom:6}}>Enviado por <span style={{color:G}}>{link.professor_nome}</span></div>
        <div style={{fontSize:13,color:T2,lineHeight:1.7,marginBottom:24}}>Olá, <strong style={{color:"#fff"}}>{nomeAluno()}</strong>! Responda 6 blocos e receba seu diagnóstico metabólico completo.</div>
        <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:8,marginBottom:24}}>
          {PILARES.map(function(p){ return <div key={p.key} style={{background:D3,border:"1px solid "+BR,borderRadius:10,padding:".9rem .5rem",textAlign:"center"}}><div style={{fontSize:20,marginBottom:4}}>{p.icon}</div><div style={{fontSize:11,color:T2}}>{p.label}</div></div>; })}
        </div>
        <button onClick={function(){ setEtapa("form"); }} style={{width:"100%",padding:"14px 0",background:G,color:D,border:"none",borderRadius:10,fontWeight:700,fontSize:15,cursor:"pointer"}}>Iniciar meu diagnóstico →</button>
        <div style={{fontSize:11,color:"#555",marginTop:12}}>Leva cerca de 5 minutos • 100% gratuito</div>
      </div>
    </div>
  );

  if (etapa === "form") {
    var pilar = PILARES[pilarIdx];
    var prog = Math.round((pilarIdx/PILARES.length)*100);
    return (
      <div style={bg}>
        <div style={{maxWidth:560,margin:"0 auto",padding:"2rem 1rem"}}>
          <div style={{marginBottom:22}}>
            <div style={{display:"flex",justifyContent:"space-between",fontSize:12,color:T2,marginBottom:6}}><span>{pilar.icon} {pilar.label}</span><span>{pilarIdx+1}/{PILARES.length}</span></div>
            <div style={{background:D4,borderRadius:4,height:5}}><div style={{background:G,height:5,borderRadius:4,width:prog+"%",transition:"width .3s"}}/></div>
          </div>
          <div style={{background:D3,border:"1px solid "+BR,borderRadius:14,padding:"1.5rem",marginBottom:16}}>
            <div style={{fontSize:26,marginBottom:6}}>{pilar.icon}</div>
            <div style={{fontSize:18,fontWeight:600,color:G,marginBottom:20}}>{pilar.label}</div>
            {pilar.perguntas.map(function(q, i) {
              return (
                <div key={i} style={{marginBottom:20}}>
                  <div style={{fontSize:13,color:T2,marginBottom:10,lineHeight:1.5}}>{q.t}</div>
                  <div style={{display:"flex",gap:8}}>
                    {[1,2,3,4,5].map(function(v) {
                      var sel = respostas[pilar.key] && respostas[pilar.key][i] === v;
                      return <button key={v} onClick={function(){ setResp(pilar.key,i,v); }} style={{flex:1,padding:"11px 0",borderRadius:9,border:sel?"2px solid "+G:"1px solid "+BR,background:sel?G+"22":D4,color:sel?G:T2,fontWeight:sel?700:400,cursor:"pointer",fontSize:14}}>{v}</button>;
                    })}
                  </div>
                  <div style={{display:"flex",justifyContent:"space-between",fontSize:10,color:BR,marginTop:4}}><span>Nunca</span><span>Sempre</span></div>
                </div>
              );
            })}
          </div>
          <button onClick={avancar} disabled={!pilarOk()} style={{width:"100%",padding:"14px 0",background:pilarOk()?G:D4,color:pilarOk()?D:T2,border:"none",borderRadius:10,fontWeight:700,fontSize:14,cursor:pilarOk()?"pointer":"not-allowed"}}>
            {pilarIdx < PILARES.length-1 ? "Próximo →" : "Ver resultado"}
          </button>
        </div>
      </div>
    );
  }

  if (etapa === "resultado" && scores) {
    enviar();
    return (
      <div style={{...bg,display:"flex",alignItems:"center",justifyContent:"center",flexDirection:"column",gap:12,textAlign:"center",padding:"2rem"}}>
        <div style={{fontSize:48}}>⏳</div>
        <div style={{fontSize:18,color:TX}}>Enviando sua avaliação...</div>
      </div>
    );
  }
  return null;
}
